import { useEffect } from "react";
import { generateStaticPieNode } from "../../graph-util";
import { extractDroppedFilesPieChunks } from "../../utils";
import { CreateControlNodeOnlyFn, PieCountsDroppedFiles } from "../../@types";

interface Props {
  renderer: CreateControlNodeOnlyFn;
  counts: { pie: PieCountsDroppedFiles; total: number };
}

const useRenderDroppedFilesRS = ({
  renderer: createControlNodeFromData,
  counts: { pie: pieCountsDroppedFiles, total: totalDroppedFiles }
}: Props) => {
  useEffect(() => {
    if (!pieCountsDroppedFiles || !totalDroppedFiles) return;
    createControlNodeFromData({
      generateControlNode: () =>
        generateStaticPieNode({
          id: "droppedFilesNode",
          label: `Dropped Files`,
          ...extractDroppedFilesPieChunks(pieCountsDroppedFiles),
          radius: 70
        })
    });
  }, [createControlNodeFromData, pieCountsDroppedFiles, totalDroppedFiles]);
};

export default useRenderDroppedFilesRS;
